import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { media } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import {
  fetchMarketingPreferences,
  handleMarketingPreferencesChange,
  setMarketingPreferences
} from "../DownloadAndDelete/actions";
import { setA11yContent } from "../NavigationHelper/actions";

import GoBack from "common-components/GoBack";
import Header from "common-components/Header";
import Alert from "common-components/Alert";
import CommonContainer from "common-components/Container";
import { Checkbox as CommonCheckbox } from "common-components/FormContent";
import Button from "common-components/Buttons";
import RectangleLoader from "common-components/RectangleLoader";
import AEMContentFromHTML from "../../../hoc/AEMContentFromHTML";

class MarketingPreferences extends Component {
  state = {
    loading: true,
    pageContent: {},
    showSuccess: false,
    defaultValues: ""
  };

  componentDidMount() {
    if (checkNestedObject(this.props, "pageContent", "sections")) {
      this.setState(
        {
          pageContent: { ...this.props.pageContent.sections[2].marketing_preferences }
        },
        () => {
          this.props.setA11yContent("marketing preferences", this.state.pageContent.sc_pagetitle);

          this.props.fetchMarketingPreferences().then(() => {
            this.setState({
              loading: false,
              defaultValues: JSON.stringify(this.props.marketingPreferences)
            });
          });
        }
      );
    }
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.setMarketingPreferences().then(() => {
      if (!this.props.error) {
        this.setState({ showSuccess: true });
      }
    });
  };

  render() {
    if (this.state.loading || this.props.loading) {
      return (
        <CommonContainer style={{ maxWidth: "none", padding: "0 20px" }}>
          <RectangleLoader />
        </CommonContainer>
      );
    }
    const { pageContent, defaultValues } = this.state;
    const hasMadeChanges = defaultValues !== JSON.stringify(this.props.marketingPreferences);

    return (
      <Fragment>
        <GoBack text={pageContent.goBack} />
        <Container>
          <Header style={{ maxWidth: "555px" }}>{convertStringToElements(pageContent.section_title)}</Header>
          <SubContainer>{convertStringToElements(pageContent.section_description)}</SubContainer>
          <Div>
            <H2>{convertStringToElements(pageContent.genericList[0].text)}</H2>
            <Form onSubmit={this.handleSubmit}>
              {this.props.marketingPreferences.map((item, i) => {
                return pageContent.genericList[1].list.map(aemList => {
                  return (
                    item.type === aemList.jsonKey &&
                    item.dataList.length !== 0 && (
                      <Fieldset key={i} style={{ borderBottom: "1px solid" }}>
                        <Legend>{aemList.jsonValue}</Legend>
                        {item.dataList.map((checkbox, x) =>
                          (item.type === "DIRECT_MAIL_INDICATOR" &&
                            window.reactGlobals.loggedInMdn !== checkbox.mtn) ||
                            (item.type !== "DIRECT_MAIL_INDICATOR" && !checkbox.contactMethod) ? null : (
                            <Checkbox
                              key={x}
                              name={item.type}
                              isMailAddressEmpty={
                                item.type === "DIRECT_MAIL_INDICATOR" && !checkbox.contactMethod
                              }
                              onChange={() =>
                                this.props.handleMarketingPreferencesChange({ ...checkbox, type: item.type })
                              }
                              checked={checkbox.value === "Y" ? true : false}
                            >
                              <span>
                                {checkbox.mtn === checkbox.contactMethod
                                  ? formatPhoneNumber(checkbox.contactMethod)
                                  : checkbox.contactMethod}
                              </span>
                              {checkbox.contactName && (
                                <span style={{ display: "block", position: "unset", width: "unset" }}>
                                  {checkbox.contactName}
                                </span>
                              )}
                            </Checkbox>
                          )
                        )}
                      </Fieldset>
                    )
                  );
                });
              })}
              <div>
                <Button
                  background={pageContent.buttons[0].type}
                  type="button"
                  onClick={() => this.props.history.goBack()}
                >
                  {pageContent.buttons[0].text}
                </Button>
                <Button
                  style={{ marginRight: "0" }}
                  background={pageContent.buttons[1].type}
                  disabled={!hasMadeChanges}
                  type="submit"
                >
                  {pageContent.buttons[1].text}
                </Button>
              </div>
            </Form>
          </Div>
        </Container>
        {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}
        {this.state.showSuccess ? (
          <Alert alertType="success" afterCloseRequest={() => this.setState({ showSuccess: false })}>
            {convertStringToElements(pageContent.genericList[2].text)}
          </Alert>
        ) : null}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ pageContent, marketingPreferences, loadingAndErrorState: { loading, error } }) => ({
  pageContent,
  marketingPreferences,
  loading,
  error
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, fetchMarketingPreferences, handleMarketingPreferencesChange, setMarketingPreferences }
  ),
  AEMContentFromHTML
)(MarketingPreferences);

const Container = styled(CommonContainer)`
  max-width: 1021px;
  margin: 0 0 0 auto;
  padding-right: 20px;

  ${media.smalldesktop`
    max-width: 700px;
    margin: 0 auto;
  `}

  ${media.tablet`
    max-width: 512px;
    margin: 0 auto;
  `}

  ${media.mobile`
    margin: 0;
    padding: 40px 16px;
  `}
`;

const Form = styled.form`
  max-width: 80%;
  margin: 0 0 0 auto;

  div {
    margin-top: 40px;
  }

  ${media.mobile`
    max-width: 100%;
    margin: 0;
  `}
`;

const SubContainer = styled.div`
  max-width: 635px;

  p {
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  }

  p:first-of-type {
    font-size: 20px;
    line-height: 19px;
    margin-bottom: 16px;
  }
`;

const Fieldset = styled.fieldset`
  margin: 24px 0;
  padding-bottom: 15px;
  position: relative;

  ${media.mobile`
    max-width: 100%;
  `}
`;

const Checkbox = styled(CommonCheckbox)`
  width: 100%;
  margin: 12px 0;
  padding: 0;
  font-size: 14px;
  line-height: 16px;

  svg,
  span {
    display: inline-block;
    max-width: 85%;
    left: auto !important;
    right: 21px !important;
  }

  ${({ isMailAddressEmpty }) =>
    isMailAddressEmpty &&
    `
    position: absolute;
    top: -15px;
  `}
`;

const Legend = styled.legend`
  font-size: 14px;
  line-height: 14px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
`;

const Div = styled.div`
  max-width: 80%;
  margin-right: auto;
  margin-left: 0;

  ${media.tablet`
    max-width: 890%;    
  `}

  ${media.mobile`
    max-width: 100%;
  `}
`;

const H2 = styled.h2`
  border-top: 1px solid;
  padding-top: 8px;
  margin: 24px 0;
  font-size: 20px;
  line-height: 19px;
`;

